<div class="chart-card" *transloco="let text; prefix: 'pages.QUIZ-CHARTS'">
  <div class="time-container">
    <div class="text-center justify-content-center">
      <div class="chart-percentage">{{ timeInMinutesAndSeconds }}</div>
      <div class="approx-text">{{ text('APPROXIMATELY') }}</div>
    </div>
  </div>
  <div class="chart-text">{{ chartTitle }}</div>
</div>
